<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="change-user-groups-modal-label">
                {{ $root.text('Switch user groups', null, true) }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body padding-bottom">
            <div v-if="updated" class="alert alert-success" role="alert">
                <div class="row">
                    <div class="col-1" style="max-width: 30px"><i class="far fa-check"></i></div>
                    <div class="col" v-html="updated"></div>
                </div>
            </div>
            <div v-else>
                <form v-on:submit.prevent="onSubmit()">
                    <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

                    <div class="form-group">
                        <searchable-option-list
                            :key="'user-groups-' + ($root.current_language || 0)"
                            v-model="user_user_groups"
                            :value="user_user_groups"
                            :multiple="true"
                            :options="user_groups"
                            field_id="change-user-groups"
                            :readonly="updating"
                            :search_placeholder="$root.text('Select user group(s)', null, true)"
                        ></searchable-option-list>
                    </div>
                </form>
            </div>
        </div>
        <div v-if="!updated" class="modal-footer">
            <span v-if="!updating">
                <button
                    :key="'apply-button'"
                    type="button"
                    class="btn btn-primary"
                    @click="onSubmit()"
                >
                    <i class="far fa-check mr-1"></i> {{ $root.text('Apply', null, true) }}
                </button>
            </span>
            <span v-else>
                <button :key="'applying-button'" type="button" class="btn btn-primary">
                    <i class="fal fa-spinner-third fa-spin mr-1"></i>
                    <span style="opacity: 0.5">{{ $root.text('Apply', null, true) }}</span>
                </button>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                errors: false,
                updating: false,
                updated: false,
                user_groups: [],
                user_user_groups: []
            }
        },
        mounted () {
            this.getUserGroups();
        },
        methods: {
            getUserGroups: function () {
                /**
                 * Send get user groups request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/user-groups/!private';
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    let options = [{
                        id: -1,
                        name: '<strong>' + this.$root.text('All user groups', null, true) + '</strong>'
                    }];
                    response.data.user_groups.forEach((item) => {
                        options.push({ id: item.id, name: item.name });
                    });
                    vm.user_groups = options;
                    //vm.user_groups = response.data.user_groups;
                })
                .catch(function (error) {
                    // Do anything?
                });
            },
            resetForm: function () {
                this.errors = false;
                this.updating = false;
                let userGroups = [];
                if (this.$root.user.user_groups) {
                    this.$root.user.user_groups.forEach((item) => {
                        if (item == 0) {
                            item = -1;
                        }
                        userGroups.push(item);
                    });
                }
                this.user_user_groups = userGroups;
                this.updated = false;
            },
            onSubmit: function () {
                this.updating = true;
                this.errors = false;

                /**
                 * Send request to API.
                 */
                const data = {
                    user_groups: (this.user_user_groups.length > 0)
                        ? ((this.user_user_groups[0] == -1) ? [0] : this.user_user_groups)
                        : null
                };

                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/user/change-user-groups';
                var vm = this;

                axios({
                    method: 'put',
                    url: url,
                    data: data,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.updated = vm.$root.text('Your user groups are switched.');
                    $('.modal-body.padding-bottom').removeClass('padding-bottom');

                    setTimeout(function () {
                        // Reload page to apply changes everywhere.
                        window.location.reload();
                    }, 2000);
                })
                .catch(function (error) {
                    vm.errors = vm.$root.text('Something went wrong, please try again', null, true);
                    if (error.response) {
                        if (error.response.status == 401) {
                            // Missing/lost API token - close modal and logout user.
                            $('#change-user-groups-modal').modal('hide');
                            vm.$root.doLogout();
                        }
                        if (error.response.data.error) {
                            vm.errors = vm.$root.text(error.response.data.error);
                        }
                    }
                })
                .finally(() =>
                    vm.updating = false
                );
            }
        }
    }
</script>

<style scoped>
    .modal-body.padding-bottom {
        padding-bottom: 220px;
    }
</style>
